import {Component, forwardRef, inject, OnInit} from "@angular/core";
import { AsyncPipe, CommonModule, JsonPipe } from "@angular/common";
import {FlexModule} from "@angular/flex-layout/flex";
import {MatTooltipModule} from "@angular/material/tooltip";
import {FormBuilder, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {PercentageInputComponent} from "../../components/percentage-input-component/percentage-input.component";
import {PercentageInputValue} from "@portal-workspace/grow-shared-library";
import {AbstractControlValueAccessor} from "../abstract-control-value-accessor";
import {MARK, Mark} from "@portal-workspace/grow-ui-library/mark";
import {Mode} from "@ngneat/edit-in-place/lib/mode";
import {PercentagePipe} from '../../pipes/percentage.pipe';
import {EditableComponent, EditableSaveDirective, EditModeDirective, ViewModeDirective} from "@ngneat/edit-in-place";


@Component({
  selector: 'editable-percentage',
  templateUrl: './editable-percentage.component.html',
  styleUrls: [ './editable-percentage.component.scss' ],
  standalone: true,
  imports: [
    CommonModule,
    FlexModule,
    JsonPipe,
    AsyncPipe,
    PercentageInputComponent,
    MatTooltipModule,
    ReactiveFormsModule,
    MatButtonModule,
    PercentagePipe,
    EditableComponent,
    EditableSaveDirective,
    EditModeDirective,
    ViewModeDirective,
  ],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(()=> EditablePercentageComponent), multi: true},
    { provide: MARK, useExisting: forwardRef(()=>EditablePercentageComponent), multi: true},
  ]
})
export class EditablePercentageComponent extends AbstractControlValueAccessor<PercentageInputValue> implements OnInit, Mark {

  mode: Mode = 'view';

  readValue: PercentageInputValue = null;
  formControl!: FormControl<PercentageInputValue>;

  formBuilder = inject(FormBuilder);

  constructor() {
    super();
    this.formControl = this.formBuilder.control(null, [Validators.required]);

  }

  mark(): void {
    this.formControl.markAllAsTouched();
  }

  ngOnInit(): void {
  }

  doWriteValue(v?: PercentageInputValue | undefined): void | PercentageInputValue {
    if (v != null || v != undefined) {
      this.readValue = v;
      this.formControl.setValue(v);
    } else {
      this.readValue = null;
      this.formControl.setValue(null);
    }
  }

  onSave() {
    if (this.formControl.valid) {
      this.readValue = this.formControl.value;
      this.propagateChange(this.readValue);
    } else {
      this.propagateChange(null);
    }
  }

  modeChange($event: Mode) {
    this.mode = $event;
  }
}
